export const API_HOST = process.env.REACT_APP_API_HOST;
export const S3_HOST = process.env.REACT_APP_S3_PUBLIC_HOST;
export const SEARCH_API_HOST = process.env.REACT_APP_SEARCH_API_URL;
export const API_PUBLIC_HOST = API_HOST + "/api/v1/public";
export const API_PRIVATE_HOST = API_HOST + "/api/v1/private";

export const QUERY_PARAM_ORIGIN_LISTING_ID_NAME = "orig-lid";
export const PLAY_STORE = "https://play.google.com/store/apps/details?id=com.kisangateway&pcampaignid=web_share";
export const APP_STORE = "https://apps.apple.com/in/app/kisan-gateway/id6474902759";
export const INSTAGRAM = "https://www.instagram.com/kisangateway";
export const TWITTER = "https://twitter.com/GatewayKisan";
export const YOUTUBE = "https://www.youtube.com/@kisangateway";
export const FACEBOOK = "https://www.facebook.com/Kisan-Gateway-101573472131388";

/**********************Export Routes */
export const CATEGORIESLIST = "/categoriesList/:slug";
export const ADDRESS = "/address";
export const UPLOADPHOTOS = "/uploadphotos";
export const UPLOAD_STORY_PHOTOS = "/story/upload-media";

export const PREVIEWLISTINGPAGE = "/PreviewListingPage";
export const PREVIEWPOSTINGPAGE = "/PreviewPostingPage";

export const EDITLISTINGTRACTOR = "/EditListingTractor";
export const EDITEDADDRESS = "/EditedAddress";
export const SERVICELIST = "/services";

const PREFIX_LISTING = "/listings";
export const GENERAL_LISTING = PREFIX_LISTING + "";
export const ADDZONELIST = PREFIX_LISTING + "/AdZoneListings";
export const DEALER_LISTING = PREFIX_LISTING + "/Dealer";
export const SERVICEPROVIDERLIST = PREFIX_LISTING + "/service-provider";
export const OFFERZONELISTINGS = PREFIX_LISTING + "/OfferZoneListings";
export const AGRI_EXPERT_LISTING = PREFIX_LISTING + "/agri-experts";

export const BUYLISTING = "/BuyListings";
export const PAYMENTSUMMARY = "/PaymentSummary";

const PREFIX_POSTING = "/postings";
export const MYPOSTINGS = PREFIX_POSTING + "";
export const GENERAL_POSTINGS = PREFIX_POSTING;
export const DEALERPOSTINGS = PREFIX_POSTING + "/DealerPostings";
export const SERVICEPROVIDERPOSTING = PREFIX_POSTING + "/ServiceProviderPostings";
export const OFFERZONEPOSTING = PREFIX_POSTING + "/OfferZoneMyPostings";
export const ADZONE_POSTING = PREFIX_POSTING + '/AdZoneMyPostings';
export const USER_STORY_POSTING = PREFIX_POSTING + "/user-story";
export const AGRI_EXPERT_POSTING = PREFIX_POSTING + "/agri-expert";
export const PURCHASE_REQUEST_POSTING = PREFIX_POSTING + "/purchase-request"

const PREFIX_PURCHASE_REQUEST = "/purchase-request";
export const PURCHASE_REQUEST = PREFIX_PURCHASE_REQUEST;
export const PURCHASE_REQUEST_DETAILS = PREFIX_PURCHASE_REQUEST + "/details";
export const PURCHASE_REQUEST_BUY_LEAD_LIST = PREFIX_PURCHASE_REQUEST + "/buy-leads";


/******************* create post routing*******************/
export const PREFIX = "/post/create_post_";
export const PREFIX_CREATE_POST = PREFIX;
export const FI = PREFIX_CREATE_POST + "FI";
export const PFS = PREFIX_CREATE_POST + "PFS";
export const INSURENCESERVICE = PREFIX_CREATE_POST + "insurenceService";

const AGENT_PREFIX = "/business-developer";
export const AGENT_BANK_DETAILS = AGENT_PREFIX + "/bank-details";
export const AGENT_CLUSTER = AGENT_PREFIX + "/mis-refferals";
export const AGENT_MIS_REPORT = AGENT_PREFIX + "/mis-report"

export const DEALERBUYPRESEARCH = "/dealer_buy_preSearch";
export const SEARCHRESULTPAGE = "/search_result";
export const GREATDEALS = "/great_deals";
export const EXCLUSIVE_PROPERTIES = "/exclusive-properties";
export const TOP_PROPERTIES = "/top-properties";
export const VERIFYREGISTER = "/verify_register";
export const REGISTERAS = "/register_as";
export const CATEGORIESITEM = "/categoryitem";

const ONBOARDING_PREFIX = "/onboarding";
export const USER_ONBOARDING = ONBOARDING_PREFIX;
export const CUSTOMER_PREFIX = ONBOARDING_PREFIX + "/customer";
export const CUSTOMER_FEATURE = CUSTOMER_PREFIX + "/features";
export const CUSTOMER_DETAILS = CUSTOMER_PREFIX + "/details";
export const DEALER_PREFIX = ONBOARDING_PREFIX + "/dealer";
export const DEALER_FEATURE = DEALER_PREFIX + "/features";
export const DEALER_CATEGORIES = DEALER_PREFIX + "/categories";
export const DEALER_DETAILS = DEALER_PREFIX + "/:categoryKey/details";
export const DEALER_PORTFOLIO = DEALER_PREFIX + "/:categoryKey/portfolio";
export const DEALER_PLANS = DEALER_PREFIX + "/:categoryKey/plans";
export const BUSINESS_DEVELOPER_PREFIX = ONBOARDING_PREFIX + "/business-developer";
export const BUSINESS_DEVELOPER_FEATURE = BUSINESS_DEVELOPER_PREFIX + "/features";
export const BUSINESS_DEVELOPER_BENEFITS = BUSINESS_DEVELOPER_PREFIX + "/benefits";
export const BUSINESS_DEVELOPER_DETAILS = BUSINESS_DEVELOPER_PREFIX + "/details";
export const BUSINESS_DEVELOPER_PLANS = BUSINESS_DEVELOPER_PREFIX + "/plans";

export const INVESTOR_PREFIX = ONBOARDING_PREFIX + "/investor";
export const INVESTOR_FEATURE = INVESTOR_PREFIX + "/features";
export const INVESTOR_DETAILS = INVESTOR_PREFIX + "/details";
export const INVESTOR_PORTFOLIO = INVESTOR_PREFIX + "/portfolio";
export const INVESTOR_PLANS = INVESTOR_PREFIX + "/plans";
export const SERVICE_PROVIDER_PREFIX = ONBOARDING_PREFIX + "/service-provider";
export const SERVICE_PROVIDER_FEATURE = SERVICE_PROVIDER_PREFIX + "/features";
export const SERVICE_PROVIDER_CATEGORIES = SERVICE_PROVIDER_PREFIX + "/categories";
export const SERVICE_PROVIDER_DETAILS = SERVICE_PROVIDER_PREFIX + "/:categoryKey/details";
export const SERVICE_PROVIDER_PORTFOLIO = SERVICE_PROVIDER_PREFIX + "/:categoryKey/portfolio";
export const SERVICE_PROVIDER_PLANS = SERVICE_PROVIDER_PREFIX + "/:categoryKey/plans";
export const OTHER_FEATURE = ONBOARDING_PREFIX + "/other/features";
export const PREFIX_USER_STORY = "/user-story";
export const USER_STORY_PREVIEW_PAGE = PREFIX_USER_STORY + "/preview";

export const PRIVACYPOLICY = "/privacypolicy";
export const TERMCONDITION = "/termcondition";
export const REFUNDPOLiCY = "/refundpolicy";
export const ADSPOLICY = "/adspolicy";
export const CONTACT_US = "/contactus";
export const ABOUT_US = "/aboutus";
export const BLOG = "/blog";
export const MY_TRANSACTION = "/my-transactions";
export const MY_ADDRESS = "/my-address";
export const MY_PROFILE = "/my-profile";
export const MY_PORTFOLIO = "/my-portfolio";
export const PORTFOLIO_RATING = "/portfolio-rating";
export const COMPLETE_PROFILE = "/complete-profile";
export const PROFILE_DETAILS = "/profile-details";
export const MY_LEADS = "/MyLeads";
export const MY_DEALERSHIP = "/my-dealership";
export const CHANGE_PASSWORD = "/change-password";
export const MY_PLANS = "/my-plans";
export const DEALER_PROFILE = "/dealer-profile";
export const DELETE_ACCOUNT = "/delete-account";

// TODO: replace this route when the shared Other details page is implemented.
export const OTHERSREG = "/otherreg";

export const DEALERPLANSLIST = "/delarsitplanslist";
export const ADZONE = "/adzone";

export const OFFERZONE = "/offerzone";
export const OFFERRESULTS = "/OfferResults";
export const OFFERINFORMATION = PREFIX_CREATE_POST + "OfferInformation";

export const ASSIGNEE_OTP_LINK = "/assigneeOTP";

export const INVOICE_LINK = "/invoices/:txnId";

export const PROFILE_LISTS = "/user/profile/list";

export const SEARCH_LINK = "/search";
export const SEARCH_LISTING_PREVIEW_LINK = SEARCH_LINK + "/:listingId";
